// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3X-oi","selects":"Documents_selects__17pF5"};